module.exports = __webpack_public_path__ + "img/header-weddingRingsSecretHeart@2x.c0e0027.jpg";